'use strict';
declare var loaderConfigSalStock: any;

module Patersons {

    export interface  StockReportScope extends ng.IScope {
        dashboardForm: ng.IFormController;
        parentController: AbstractController;
        date: Date;
        isLoading: boolean;
        isinToView: string;
        portfolioLink: string;
        portfolioLinkText: string;
        portfolioName: string;
        salControlToUse: string;
        salControlLabel: string;
        securityId: string;
    }

    export class StockReportCtrl extends PortfolioBaseCtrl {
        scope: Patersons.StockReportScope;
        timeout: any;
        salReportScope: Array<any> = []

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.parentController = this;
            this.scope.date = new Date();
            this.scope.securityId = $stateParams.secId;
            this.timeout = $timeout;
            this.load();
        }
        salStockReportTransform() {
            morningstar.asterix.ng.transforms.register('fromAuClientResearch', function (input) {
                if (!input) {
                    return input;
                }
                return {
                    title: input.title,
                    url: input.url,
                    date: new Date(input.dateWritten),
                    author: input.author,
                    recommendation: input.licenseeRecommendation,
                    recommendationChange: input.recommendationChange
                };
            });

            morningstar.asterix.ng.transforms.register('fromAuDocumentList', function (input) {
                if (!input || !input.arcDocumentList || !input.arcDocumentList.length) {
                    return input;
                }
                return {
                    title: input.arcDocumentList[0].byLine ? input.arcDocumentList[0].byLine : input.arcDocumentList[0].title,
                    url: input.arcDocumentList[0].url,
                    date: new Date(input.arcDocumentList[0].date)
                };
            });
        }

        load() {
            this.log.info("SAL report Ctrl loading...");
            let self = this;
            var isinData = this.state.params['secId']
                ? this.state.params['secId']
                : "";
                if (isinData) {
                    $('#SalContainer').data('$injector', '')
                $.ajax(SALauthUrl).then(function (authData) {
                    loaderConfigSalStock.configuration.overrides.settings.shareClassId = isinData;
                    loaderConfigSalStock.apiTokens.apiGatewayToken = authData.body;
                    morningstar.loader.load(loaderConfigSalStock).then(function (manifest) {
                        //setup sal stock report transform
                        self.salStockReportTransform();
                        $('#main-spinner').remove()
                    }).catch(function (error) {
                        console.log(error);
                    });

                })
            } else {
                this.state.go('dashboard')
            }
        }
    }
}
